import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";

function getPostBoxEntries() {
    return axios.post("?Mode=MeinServicebereich&Function=GetPostBoxEntries");
}

function getPostBoxFile(fileid) {
    return axios.get(
        "?Mode=MeinServicebereich&Function=GetPostBoxFile?fileid=" + fileid
    );
}

function getPostBoxSettings() {
    return axios.post("?Mode=MeinServicebereich&Function=GetPostBoxSettings");
}

function setPostBoxSettings(data) {
    const dataString = getDataString(data);
    return axios.post(
        "?Mode=MeinServicebereich&Function=SetPostBoxSettings",
        dataString
    );
}

export {
    getPostBoxEntries,
    getPostBoxFile,
    getPostBoxSettings,
    setPostBoxSettings,
};
